// extracted by mini-css-extract-plugin
module.exports = {"header":"styles__header--n2BV8","iconHeader":"styles__iconHeader--2yCN0"};